import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import Loading from "./Loading";
import "../css/WaitingListStatus.css";
const formatDateRange = (start, end) => {
  const fmt = (d) =>
    d
      ? new Date(d).toLocaleString("pl-PL", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "—";
  return `${fmt(start)} - ${fmt(end)}`;
};

const WaitingListStatus = () => {
  const { reservationGuid } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        setIsLoading(true);
        setNotFound(false);
        const res = await api.getWaitingListStatus(reservationGuid);
        setData(res);
      } catch (err) {
        if (err?.response?.status === 404) setNotFound(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStatus();
  }, [reservationGuid]);

  if (isLoading) return <Loading />;

  if (notFound || !data) {
    return (
      <div className="mail-preview-body">
        <div className="content">
          <div className="center">
            <img className="logo" src="/logo.png" alt="Logo" />
          </div>

          <p className="greeting">
            Cześć <strong>😊</strong>
          </p>

          <p>
            Rezerwacja nie istnieje lub{" "} nie znajduje się na {" "}
            <span className="status">liście rezerwowej</span>. Listę aktualnie zaplanowanych wycieczek znajdziesz klikając przycisk <i>Powrót do strony głównej</i> w prawym górnym rogu.
          </p>
        </div>
      </div>
    );
  }

  const reservationCode = data.reservationCode ?? data.registrationCode ?? "—";
  const tripName = data.tripName ?? "—";
  const variantName = data.variantName ?? "—";
  const dateRange = formatDateRange(data.startDate, data.endDate);

  return (
    <div className="mail-preview-body">
      <div className="content">
        <div className="center">
          <img className="logo" src="/logo.png" alt="Logo" />
        </div>

        <p className="greeting">
          Cześć <strong>😊</strong>
        </p>

        <p>
          Twoja rezerwacja obecnie znajduje się na {" "}
          <span className="status">liście rezerwowej</span> – poniżej
          znajdziesz aktualne informacje oraz pozycję na liście.
        </p>
        <table className="info-table">
          <tbody>
            <tr>
              <td>Numer rezerwacji</td>
              <td className="value">{reservationCode}</td>
            </tr>
            <tr>
              <td>Nazwa wydarzenia</td>
              <td className="value">{tripName}</td>
            </tr>
            <tr>
              <td>Wariant</td>
              <td className="value">{variantName}</td>
            </tr>
            <tr>
              <td>Data wydarzenia</td>
              <td className="value">{dateRange}</td>
            </tr>
            <tr>
              <td>Status rezerwacji</td>
              <td className="status">Lista rezerwowa</td>
            </tr>
            <tr>
              <td>Pozycja na liście rezerwowej</td>
              <td className="value">{data.position ?? "—"}</td>
            </tr>
          </tbody>
        </table>

        <div className="footer">
          <p>
            <strong>Co dalej?</strong>
            <br />
            Nawet odległe miejsce na liście rezerwowej nie oznacza, że nie uda się
            dostać na wyjazd. Sytuacja jest dynamiczna — szczególnie w pierwszej
            fazie zapisów, ale również w późniejszych terminach, gdy część osób
            rezygnuje z różnych przyczyn.
          </p>

          <p>
            Osoby koordynujące na bieżąco reagują na odwołania rezerwacji i
            przydzielają miejsca kolejnym osobom z listy rezerwowej. O zmianie
            statusu zostaniesz poinformowanx mailowo, a w szczególnych przypadkach
            również telefonicznie.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WaitingListStatus;